import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-stagehistory',
  imports: [],
  templateUrl: './nav-stage-history.html',
  styleUrl: './nav-stage-history.css'
})
export class NavStageHistory {
    constructor(private router:Router){}
navigateToFullTable() {
    this.router.navigate(['/opportunities-detail-table']);
  }
}